import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import differenceWith from 'lodash/differenceWith';
import isEqual from 'lodash/isEqual';
import assign from 'lodash/assign';

import SocialLogin from './../SocialLogin';
import TextInput from './../../Inputs/TextInput';
import CheckboxInput from './../../Inputs/CheckboxInput';
import RegisterFieldsInput from './../../Inputs/RegisterFieldsInput';
import Button from '../../Inputs/Button';
import {
    required,
    email,
    matchPass,
    minLength,
} from './../../../../utils/validators';
import i18n from '../../../../i18n/i18n.js';
import { decodeHTMLEntities } from '../../../../utils';

const minLength2 = minLength(2, 'username');
const minLength8 = minLength(8, 'password');

class RegisterForm extends Component<Props> {
    constructor(props) {
        super(props);

        this.state = {
            hover: {},
        };
    }

    toggleHover = name => {
        let hasHover = {};
        hasHover[name] = this.state.hover[name]
            ? !this.state.hover[name]
            : true;
        this.setState({
            hover: hasHover,
        });
    };

    render() {
        const props = this.props;
        const lng = props.lng;
        let registerFields = props.initialValues.registerFields;
        let splitFields = [];
        let isSplitUp = false;

        registerFields &&
            registerFields.forEach(field => {
                if (field.name === 'first_name')
                    splitFields.splice(0, 0, field);

                if (field.name === 'surname') splitFields.splice(1, 0, field);
            });

        if (splitFields.length !== 0) isSplitUp = true;

        if (isSplitUp)
            registerFields = differenceWith(
                registerFields,
                splitFields,
                isEqual
            );

        return (
            <Fragment>
                <SocialLogin social={props.social} />
                <section id="ipx-maincontent" className="register">
                    <form
                        className="formelements"
                        onSubmit={props.handleSubmit}
                    >
                        <Field
                            component={TextInput}
                            type="email"
                            name="email"
                            label={`${i18n.t('placeholder_email_address', {
                                lng,
                            })}*`}
                            className="labelholder"
                            validate={[required, email]}
                            lng={lng}
                            handleFocus={props.handleFocus}
                            active={
                                props.name === 'email' ? props.active : false
                            }
                            primaryColor={props.branding.paywall_primary_color}
                        />
                        {isSplitUp ? (
                            <RegisterFieldsInput
                                registerFields={splitFields}
                                handleFocus={props.handleFocus}
                                active={
                                    props.name === 'email'
                                        ? props.active
                                        : false
                                }
                                name={props.name}
                                primaryColor={
                                    props.branding.paywall_primary_color
                                }
                            />
                        ) : (
                            <Field
                                component={TextInput}
                                type="text"
                                name="full_name"
                                label={`${i18n.t('full_name', { lng })}*`}
                                className="labelholder registerfield"
                                validate={[required, minLength2]}
                                lng={lng}
                                handleFocus={props.handleFocus}
                                active={
                                    props.name === 'full_name'
                                        ? props.active
                                        : false
                                }
                                primaryColor={
                                    props.branding.paywall_primary_color
                                }
                            />
                        )}
                        <Field
                            component={TextInput}
                            type="password"
                            name="password"
                            label={`${i18n.t('placeholder_password', {
                                lng,
                            })}*`}
                            className="labelholder pswresetfield"
                            validate={[required, minLength8]}
                            lng={lng}
                            handleFocus={props.handleFocus}
                            active={
                                props.name === 'password' ? props.active : false
                            }
                            primaryColor={props.branding.paywall_primary_color}
                        />
                        <Field
                            component={TextInput}
                            type="password"
                            name="password_confirmation"
                            label={`${i18n.t('placeholder_repeat_password', {
                                lng,
                            })}*`}
                            className="labelholder pswresetfield"
                            validate={[required, matchPass]}
                            lng={lng}
                            handleFocus={props.handleFocus}
                            active={
                                props.name === 'password_confirmation'
                                    ? props.active
                                    : false
                            }
                            primaryColor={props.branding.paywall_primary_color}
                            iconName="lock-repeat"
                        />

                        <RegisterFieldsInput
                            registerFields={registerFields}
                            handleFocus={props.handleFocus}
                            active={props.active}
                            name={props.name}
                            primaryColor={props.branding.paywall_primary_color}
                        />

                        <Field
                            component={CheckboxInput}
                            value="accepted"
                            id="ipx-register"
                            name="terms"
                            className="registerfield checkholder terms"
                            type="checkbox"
                            labelClass="checklabel"
                            label={[
                                <span key={1}>{i18n.t('agree', { lng })}</span>,
                                <a
                                    className="termslink"
                                    href="https://inplayer.com/terms/"
                                    target="_blank"
                                    rel="noopener noreferrer" //target="_blank" without rel="noopener noreferrer" is a security risk
                                    key={2}
                                >
                                    {i18n.t('terms', { lng })}
                                </a>,
                                '*',
                            ]}
                            primaryColor={props.branding.paywall_primary_color}
                            toggleHover={this.toggleHover}
                            hover={this.state.hover}
                        />
                        <div className="inplayer-buttonholder">
                            <div className="buttonholder">
                                <Button
                                    text={i18n.t('modal_register_capital', {
                                        lng,
                                    })}
                                    backgroundColor={
                                        props.branding.paywall_buttons_bg_color
                                    }
                                    touched={
                                        props.params && props.params.anyTouched
                                    }
                                    errors={
                                        props.params && props.params.syncErrors
                                            ? true
                                            : false
                                    }
                                    terms={
                                        props.params &&
                                        props.params.values &&
                                        props.params.values.terms
                                    }
                                    isLoading={props.isLoading}
                                    form="registerForm"
                                />
                            </div>
                        </div>
                    </form>
                </section>
            </Fragment>
        );
    }
}

export const mapStateToProps = (state: Object, ownProps: Object) => {
    let assignObj = {};
    let registerFields =
        ownProps.registerFields &&
        ownProps.registerFields.map((field, index) => {
            const isUndefined =
                ownProps.registerFields[field.name] === 'undefined' ||
                ownProps.registerFields[field.name] === undefined;

            assignObj = assign(assignObj, {
                [field.name]: isUndefined
                    ? decodeHTMLEntities(field.default_value) || ''
                    : decodeHTMLEntities(ownProps.registerFields[field.name]),
            });

            return {
                default_value:
                    decodeHTMLEntities(field.default_value) === ''
                        ? decodeHTMLEntities(field.placeholder)
                        : decodeHTMLEntities(field.default_value),
                id: field.id,
                name: decodeHTMLEntities(field.name),
                label: decodeHTMLEntities(field.label),
                options: field.options,
                placeholder: decodeHTMLEntities(field.placeholder),
                required: field.required,
                type: field.type,
                originalName: field.name,
                [field.name]: isUndefined
                    ? ''
                    : decodeHTMLEntities(ownProps.registerFields[field.name]),
            };
        });

    let initialValues = {
        registerFields,
    };

    initialValues = assign(initialValues, assignObj);

    return {
        initialValues: initialValues,
    };
};

RegisterForm = reduxForm({
    form: 'registerForm',
    enableReinitialize: true,
})(RegisterForm);

export default connect(
    mapStateToProps,
    null
)(RegisterForm);



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Register/index.js